const {
    get_stripe_instance,
    get_stripe_card_instance
} = require("../sub/stripe.js");

const fetch_option_template = {
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    mode: 'cors',
    credentials: 'include' // クッキーの送信

};

const prepare_fetch_option = (blob_fetch_option) => {
    return {...fetch_option_template,...blob_fetch_option}
};

const form_into_json = async () => {

    let blob_tokendata;
    let stripe;
    let card;

    stripe = get_stripe_instance();
    card = get_stripe_card_instance();

    DOM_form = document.querySelector('#modal-1 #application');
    if(DOM_form === null){
        return; 
    } else {
        formdata = new FormData(DOM_form);
    }

    //後で整理：
    //FormDataはオブジェクトを正しく格納しない。
    //formdata.append('stripe_token',blob_tokendata.token);
    //formdata.get('stripe_token') // <-- [object Object] になってしまう。

    blob_form = Object.fromEntries(formdata.entries());
    
    // FIXME:ここで処理分けするべきか、再度検討する
    // フォームの内容をJSONに変換する処理がフォームのinput要素の有無に左右されるのは正しいといいにくい。
    if(blob_form['payment_method'] == 'credit'){
        blob_tokendata = await stripe.createToken(card);

        if(blob_tokendata.error){
            //
            console.log('stripe token creation failed:');
            console.log(blob_tokendata.error);
    
            return;
        }
        blob_form['stripe_token'] = blob_tokendata.token;
    }
    
    console.log(JSON.stringify(blob_form,null,"    "));
    return JSON.stringify(blob_form);
};

module.exports.do_application = async (context) => {
    let JSON_form_input;
    let fetch_option;
    let JSON_response;
    let server_response;
    let server_endpoint;

    server_endpoint= `${window.backend_fqdn}/contest_application`;
    JSON_form_input = await form_into_json();
    
    fetch_option = prepare_fetch_option({
        body:JSON_form_input
    });

    await opening_appliction();

    context.server_response = await fetch(server_endpoint,fetch_option);

    return await closing_appliction(context);
};

const opening_appliction = async (context)=>{

};
const closing_appliction = async (context)=>{
    //,server_response
    blob_response = await context.server_response.json();
    console.log(blob_response);

    if(blob_response.result != "success"){
    }
    
    return blob_response;
};


